import { AddOutlined, DeleteOutline, EditOutlined } from "@mui/icons-material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, CustomButton, TableData } from "../../../../components";


import { confirmAlert, errorAlert } from "../../../../helpers/alerts";
import { Grid } from "@mui/material";
import { removePINSegment, setCurrentPINSegment, updatePINSegment } from "redux/slices/admin/productSlice";
import { removePINSegmentService, updatePINSegmentService } from "services/admin/productService";

const SegmentsPINScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pinSegments } = useSelector((state) => state.products);

  const handlerEdit = (row) => {
    dispatch(setCurrentPINSegment(row));
    navigate("editar");
  };

  const handlerCheck = async ({ id }, currentValue, col) => {
    const value = !currentValue;
    updatePINSegmentService(id, { [col]: value })
      .then(() => dispatch(updatePINSegment({ id, data: { [col]: value } })))
      .catch(error => errorAlert(error))

  };

  const handlerDelete = ({ id, name }) => {
    confirmAlert({
      title: "Estas seguro que deseas eliminar este segmento?",
      text: `El segmento ${name} será eliminado.`,
      onConfirm: async () => {
        try {
          await removePINSegmentService(id);
          dispatch(removePINSegment(id));
        }
        catch (error) {
          errorAlert(error)
        }
      }
    })
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton
            name={"Volver"}
            click={() => navigate(-1)}
          />
        </div>
        <div className="container-title">
          <div className="title">Segmentos</div>
        </div>
        <div>
          <CustomButton
            icon={<AddOutlined  />}
            additional_class={"headerButton"}
            key="add"
            name={"Segmento"}
            click={() => navigate("crear")}
          />
        </div>
      </Grid>
      <TableData
        dataRows={pinSegments}
        dataTitle={["Logo", "Nombre", "Estado"]}
        formatter={({ name, state, fd }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          { name: "state", type: "boolean", value: state },
        ]}
        onChecked={handlerCheck}
        actions={[
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: (data) => {
              handlerEdit(data);
            },
          },
          {
            label: "Eliminar",
            icon: <DeleteOutline />,
            onClick: (data) => {
              handlerDelete(data);
            },
          },
        ]}
      />
    </>
  );
};

export default SegmentsPINScreen;
